import { withPluginApi } from 'discourse/lib/plugin-api';

export default {
  name: 'proxyviews-directory-admin',

  initialize(owner) {
    const currentUser = owner.lookup('service:current-user');
    if (!currentUser || !currentUser.admin) {
      return;
    }

    withPluginApi('0.8.31', (api) => {
      // Add a sidebar link in the Admin section
      api.addAdminSidebarSectionLink('root', {
        name: 'proxyviews-directory',
        route: 'adminPlugins.proxyviews-directory',
        label: 'proxyviews.directory.admin.nav_label',
        title: 'proxyviews.directory.admin.nav_label',
        icon: 'th-large',
      });
    });
  },
};
